import { Form } from 'factorial-form'

class TimeoffPolicySelectForm extends Form {
  constructor(values: {}) {
    super(values, {
      timeoff_policy_id: 'string',
      timeoff_allowance_id: 'string',
    })
  }
}

export default TimeoffPolicySelectForm
